module.exports = __webpack_public_path__ + "img/vk.c2176d60.svg";